"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroupField = exports.CheckboxInputField = exports.PasswordField = exports.EmailField = exports.TextInputField = void 0;
const formik_1 = require("formik");
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const addFormikFieldProps = (name) => {
    const { errors, touched, values, handleBlur, handleChange } = (0, formik_1.useFormikContext)();
    return {
        // @ts-ignore
        error: errors[name],
        // @ts-ignore
        touched: touched[name],
        // @ts-ignore
        value: values[name],
        onBlur: handleBlur,
        onChange: handleChange,
    };
};
const TextInputField = (_a) => {
    var { name } = _a, rest = __rest(_a, ["name"]);
    return (react_1.default.createElement(components_1.Input, Object.assign({ name: name }, rest, addFormikFieldProps(name))));
};
exports.TextInputField = TextInputField;
exports.TextInputField.defaultProps = components_1.Input.defaultProps;
const EmailField = (_a) => {
    var { name, placeholder } = _a, rest = __rest(_a, ["name", "placeholder"]);
    return (react_1.default.createElement(components_1.EmailInput, Object.assign({}, rest, { name: name, placeholder: placeholder }, addFormikFieldProps(name))));
};
exports.EmailField = EmailField;
exports.EmailField.defaultProps = components_1.Input.defaultProps;
const PasswordField = (_a) => {
    var { name, placeholder } = _a, rest = __rest(_a, ["name", "placeholder"]);
    return (react_1.default.createElement(components_1.PasswordInput, Object.assign({}, rest, { placeholder: placeholder, name: name }, addFormikFieldProps(name))));
};
exports.PasswordField = PasswordField;
exports.PasswordField.defaultProps = components_1.Input.defaultProps;
const CheckboxInputField = (_a) => {
    var { name, label } = _a, rest = __rest(_a, ["name", "label"]);
    return (react_1.default.createElement(components_1.Checkbox, Object.assign({ id: name, name: name, label: label }, rest, addFormikFieldProps(name))));
};
exports.CheckboxInputField = CheckboxInputField;
const RadioGroupField = (_a) => {
    var { name, options } = _a, rest = __rest(_a, ["name", "options"]);
    const { onChange, value } = addFormikFieldProps(name);
    return (react_1.default.createElement(components_1.RadioGroup, Object.assign({ value: value, options: options, onChange: onChange }, rest)));
};
exports.RadioGroupField = RadioGroupField;
